// utils.js
export function decodeJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = atob(base64);
    const parsedPayload = JSON.parse(decodedPayload);
    return parsedPayload;
  }
  